import {Component, Input, OnInit} from '@angular/core';
import {NgClass, NgFor, NgIf, NgStyle} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ResultsDto} from '../../models/card.model';

@Component({
  selector: 'app-card-results',
  templateUrl: './card-results.component.html',
  styleUrls: ['./card-results.component.scss'],
  standalone: true,
  imports: [NgStyle, NgClass, NgIf, NgFor, IonicModule],
})
export class CardResultsComponent implements OnInit {
  @Input() results: ResultsDto;

  constructor() {
  }

  ngOnInit() {
    console.log('Results:', this.results);
  }

  protected readonly parseInt = parseInt;
}
